"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _dist = require("package_ui_ihm/dist");
var _Divider = _interopRequireDefault(require("@mui/material/Divider"));
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
* Nom : userList.js
* Description : Ce fichier contient la définition de la page userList 
*               Cette page liste les utilisateurs
* Date de création : 30 septembre 2025
*/ /* CSS et assets */ /* Bibliothèques et composants */ /* Hook */ /**
* UserList : affiche la page qui liste les utilisateurs
*            filtrage de la liste possible selon le role et le status du compte 
*            un lien permet d'afficher une page avec un formulaire pour créer un nouvel utilisateur
*            pour chaque utilisateur une icone permet d'accéder à la page qui permet de modifier le compte utilisateur 
*
* Type : page 
*
* Parametres : 
*  None
*/
function UserList() {
  // Define useState hooks

  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    users = _useState2[0],
    setUsers = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    statusUsers = _useState4[0],
    setStatusUsers = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDataLoading = _useState6[0],
    setDataLoading = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    roles = _useState8[0],
    setRoles = _useState8[1];
  var _useState9 = (0, _react.useState)([]),
    _useState0 = _slicedToArray(_useState9, 2),
    statusAccounts = _useState0[0],
    setStatusAccounts = _useState0[1];
  var _useState1 = (0, _react.useState)(0),
    _useState10 = _slicedToArray(_useState1, 2),
    selectedRole = _useState10[0],
    setSelectedRole = _useState10[1];
  var _useState11 = (0, _react.useState)(0),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedStatusAccount = _useState12[0],
    setSelectedStatusAccount = _useState12[1];
  var _useState13 = (0, _react.useState)([]),
    _useState14 = _slicedToArray(_useState13, 2),
    filteredUsers = _useState14[0],
    setFilteredUsers = _useState14[1];
  var _useState15 = (0, _react.useState)([]),
    _useState16 = _slicedToArray(_useState15, 2),
    filteredCompanyUsers = _useState16[0],
    setFilteredCompanyUsers = _useState16[1];

  // Define useContext hooks
  var _useAuth = (0, _dist.useAuth)(),
    authStatus = _useAuth.authStatus,
    authToken = _useAuth.authToken,
    currentUser = _useAuth.currentUser;
  var _useApi = (0, _dist.useApi)(),
    path = _useApi.path,
    selectedCompany = _useApi.selectedCompany,
    applicationName = _useApi.applicationName;
  var navigate = (0, _reactRouterDom.useNavigate)();

  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Define functions
  function retrieve_param_object_from_id(list, id) {
    return list.find(function (item) {
      return item['id'] === Number(id);
    })['value'];
  }
  function updateFilteredUsers() {
    // Filtering of role
    if (Number(selectedRole) > 0 && Number(selectedStatusAccount) === 0) {
      setFilteredUsers(filteredCompanyUsers.filter(function (user) {
        return user.role["id"] === Number(selectedRole);
      }));
    }
    // Filtering of status account
    else if (Number(selectedRole) === 0 && Number(selectedStatusAccount) > 0) {
      setFilteredUsers(filteredCompanyUsers.filter(function (user) {
        return Number(user.is_active) === retrieve_param_object_from_id(statusAccounts, Number(selectedStatusAccount));
      }));
    }
    // Filtering of role and status account
    else if (Number(selectedRole) > 0 && Number(selectedStatusAccount) > 0) {
      setFilteredUsers(filteredCompanyUsers.filter(function (user) {
        return Number(user.is_active) === retrieve_param_object_from_id(statusAccounts, Number(selectedStatusAccount)) && user.role["id"] === Number(selectedRole);
      }));
    }
    // No filter
    else {
      setFilteredUsers(filteredCompanyUsers);
    }
  }
  function updateFilteredCompanyUsers() {
    // Filtering company
    if (selectedCompany > 0) {
      setFilteredCompanyUsers(users.filter(function (equipment) {
        return equipment.company["id"] === Number(selectedCompany);
      }));
    } else {
      setFilteredCompanyUsers(users);
    }
  }
  function retrieveData() {
    return _retrieveData.apply(this, arguments);
  }
  function _retrieveData() {
    _retrieveData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var token, headers, _yield$Promise$all, _yield$Promise$all2, resRole, resUser, _yield$Promise$all3, _yield$Promise$all4, dataRole, dataUser, status_account_dict;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Headers
            headers = {
              accept: 'application/json',
              Authorization: token
            }; // Requests in parallel to win time 
            _context.n = 1;
            return Promise.all([
            // Roles
            fetch(path + "/api/au-lero/extract-filter/", {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: headers
            }),
            // Users
            fetch(path + "/api/au-erus/extract/", {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: headers
            })]);
          case 1:
            _yield$Promise$all = _context.v;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            resRole = _yield$Promise$all2[0];
            resUser = _yield$Promise$all2[1];
            _context.n = 2;
            return Promise.all([resRole.json(), resUser.json()]);
          case 2:
            _yield$Promise$all3 = _context.v;
            _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 2);
            dataRole = _yield$Promise$all4[0];
            dataUser = _yield$Promise$all4[1];
            // Set variables
            setRoles(dataRole);
            setStatusUsers(resUser["status"]);
            setUsers(dataUser);
            // Status du compte 
            status_account_dict = [{
              "id": 1,
              "value": 1,
              "description": "Actif"
            }, {
              "id": 2,
              "value": 0,
              "description": "Inactif"
            }];
            setStatusAccounts(status_account_dict);
            // Dataloading
            setDataLoading(false);
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _retrieveData.apply(this, arguments);
  }
  var handleIcon = function handleIcon(event, id) {
    event.preventDefault();
    var target_path = '/users/' + id + "/edit";
    navigate(target_path);
  };
  var filterReset = function filterReset(event) {
    event.preventDefault();
    setFilteredUsers(users);
    setSelectedRole(0);
    setSelectedStatusAccount(0);
  };

  // Define useEffect hooks
  (0, _react.useEffect)(function () {
    if (authStatus === 200) {
      setDataLoading(true);
      retrieveData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(function () {
    updateFilteredCompanyUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [users, selectedCompany]);
  (0, _react.useEffect)(function () {
    updateFilteredUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredCompanyUsers, selectedRole, selectedStatusAccount]);

  // Render component
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [applicationName === "BOXILUMIX" ? currentUser && (currentUser["role_name"] === "AT_ADMIN" || currentUser["role_name"] === "AT_SUPPORT") ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.CompanyBar, {
      name_app: "BOXILUMIX"
    }) : null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.CompanyBar, {
      name_app: "BOXIBRAIN"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.TabC, {
      tabNumber: 5
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: screenWidth > 650 ? 'App' : 'App-ss',
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.Container, {
        children: isDataLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: "Chargement des donn\xE9es"
        }) : statusUsers === 200 ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: screenWidth > 650 ? 'grid-1-3' : null,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "flex-rows",
              children: [currentUser["role_name"] === "AT_ADMIN" || currentUser["role_name"] === "AT_SUPPORT" || currentUser["role_name"] === "COMPANY_ADMIN" && applicationName === 'BOXILUMIX' ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: "flex-rows",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.AddItem, {
                  path: "/users/new",
                  children: "Ajouter un utilisateur"
                })
              }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                children: "Filtres"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.ListFilter, {
                labelText: "R\xF4le",
                choices: roles.sort(function (a, b) {
                  return a.description > b.description ? 1 : -1;
                }),
                choiceParam: 'description',
                selectedItem: selectedRole,
                setSelectedItem: setSelectedRole,
                subfilter: false
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.ListFilter, {
                labelText: "Status du compte",
                choices: statusAccounts,
                choiceParam: 'description',
                selectedItem: selectedStatusAccount,
                setSelectedItem: setSelectedStatusAccount,
                subfilter: false
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                  onClick: filterReset,
                  className: "button-secondary clickable",
                  children: "Sans filtres"
                })
              })]
            }), screenWidth > 650 ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider["default"], {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "scroll-list-c",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("h2", {
                className: "subtitle",
                children: ["Nombre d'utilisateur : ", filteredUsers.length]
              }), filteredUsers && filteredUsers.length !== 0 ? filteredUsers.sort(function (a, b) {
                return a.username > b.username ? 1 : -1;
              }).map(function (user) {
                return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.Item, {
                  id: user['id'],
                  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    children: [Number(user["is_active"]) === 1 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                      className: "grid-1-1",
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("h3", {
                        className: "item-text",
                        children: [user['first_name'], " ", user['last_name']]
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        className: "flex-row justify-end",
                        children: currentUser["role_name"] === "AT_ADMIN" || currentUser["role_name"] === "AT_SUPPORT" && Number(user['role']['id']) < 4 || currentUser["role_name"] === "COMPANY_ADMIN" && Number(user['role']['id']) < 3 && applicationName === 'BOXILUMIX' ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                          src: _dist.EditIcon,
                          alt: "edit_item_icon",
                          onClick: function onClick(e) {
                            return handleIcon(e, user['id']);
                          },
                          className: "link-img"
                        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {})
                      })]
                    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                      className: "grid-1-1",
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("h3", {
                        className: "item-text",
                        children: [user['first_name'], " ", user['last_name'], " (inactif) "]
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        className: "flex-row justify-end",
                        children: currentUser["role_name"] === "AT_ADMIN" || currentUser["role_name"] === "AT_SUPPORT" && Number(user['role']['id']) < 4 || currentUser["role_name"] === "COMPANY_ADMIN" && Number(user['role']['id']) < 3 && applicationName === 'BOXILUMIX' ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                          src: _dist.EditIcon,
                          alt: "edit_item_icon",
                          onClick: function onClick(e) {
                            return handleIcon(e, user['id']);
                          },
                          className: "link-img"
                        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {})
                      })]
                    }), screenWidth > 650 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                        className: "grid-1-2",
                        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
                          className: "item-text",
                          children: ["Username : ", user['username']]
                        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
                          className: "item-text",
                          children: ["Email : ", user['email']]
                        })]
                      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                        className: "grid-1-2",
                        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
                          className: "item-text",
                          children: ["Soci\xE9t\xE9 : ", user['company']['name']]
                        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
                          className: "item-text",
                          children: ["Role : ", user['role']['description']]
                        })]
                      })]
                    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
                        className: "item-text",
                        children: ["Username : ", user['username']]
                      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
                        className: "item-text",
                        children: ["Email : ", user['email']]
                      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
                        className: "item-text",
                        children: ["Soci\xE9t\xE9 : ", user['company']['name']]
                      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
                        className: "item-text",
                        children: ["Role : ", user['role']['description']]
                      })]
                    })]
                  })
                }, user['id']);
              }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                children: "Aucun utilisateur actuellement."
              })]
            })]
          })
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
          children: "Connexion failed"
        })
      })
    })]
  });
}
var _default = exports["default"] = UserList;